import { Box } from '@mui/material';
import { SearchKeyInput, SearchKeyInputItems } from '../../component/form/search-key-input.component';
import TableComponent, { HeadCell, TableRowFeatures } from '../../component/table/table.component';
import i18n from '../../i18n';
import { DeliverectLogState } from './deliverect-log-state';
import { observer } from 'mobx-react-lite';
import DeleteDialogComponent from '../../component/dialog/delete-dialog.component';
import DialogComponent from '../../component/dialog/dialog.component';
import Highlight from 'react-highlight';
import { dateFormat } from '../../constants/utils';

const DeliverectOrderList = observer(({ useData }: { useData: DeliverectLogState }) => {
    // 表格顶部下拉框数组
    const selectFilterLists: SearchKeyInputItems[] = [
        {
            value: 'string_id',
            label: i18n.t('ground_staff_component_text_restaurant_code'),
            type: 'TEXT'
        }];

    // 表格头部数据
    const table_head_cell_project: HeadCell[] = [
        // 集团
        { id: 'string_id', label: i18n.t('ground_staff_component_text_restaurant_code') },
        // 集团
        { id: 'order_id', label: i18n.t('business_analysis_page_order_account') },
        {
            id: 'create_date',
            label: i18n.t('restaurant_extensions_page_text_create_time'),
            renderFunction: (row: any) => (<div>{dateFormat(row.order._created, 'YYYY/MM/DD HH:mm:ss')}</div>)
        },
        // 详情
        {
            id: 'action',
            label: '',
            renderFunction: (row: any) => (
                <TableRowFeatures
                    buttons={[
                        {
                            variant: 'contained',
                            color: 'secondary',
                            action: 'DELETE',
                            handleClick: () => {
                                useData.setDialog({
                                    open: true, message: [i18n.t('account_manager_confirm_delete')],
                                    option: [
                                        [i18n.t('account_manager_yes'), async () => {
                                            await useData.handleDeleteOrder(row);
                                            useData.setDialog({ open: false })
                                        }],
                                        [i18n.t('general_button_cancel'), () => {
                                            useData.setDialog({ open: false })
                                        }]
                                    ],
                                })
                            }
                        },
                        {
                            variant: 'contained',
                            action: 'VIEW',
                            handleClick: async () => {
                                useData.setOpenDetailDialog({ open: true, data: row })
                            }
                        }
                    ]}
                />
            )
        },
    ]


    /**
     * 把object转成json string
     * @param obj 
     */
    const formatJson = (obj: object) => {
        try {
            return JSON.stringify(obj, null, 2)
        } catch {
            return ''
        }
    }
    return (
        <div>
            <Box sx={{
                marginTop: 2,
                marginBottom: 3,
            }}>
                <SearchKeyInput
                    items={selectFilterLists as SearchKeyInputItems[]}
                    conditions={useData.paramCondition}
                    onSearch={(value) => useData.setParamConditions(value)}
                    showConditionsBox
                />
            </Box>
            <TableComponent
                {...{
                    showChecked: 0,
                    list: useData.unSendOrderList,
                    isPagination: true,
                    headCellList: table_head_cell_project,
                    isTableLoading: useData.isTableLoading,
                    allCount: useData.unSendOrderList.length,
                    isUseFold: true,
                    extraClass: 'extraTable',
                }}
            />
            {/* 删除弹窗 是否删除所选择项目 */}
            <DeleteDialogComponent
                {...{
                    title: i18n.t('general_text_tips'),
                    desc: i18n.t('account_manager_confirm_delete'),
                    open: useData.dialog?.open ?? false,
                    onCancel: () => {
                        useData.dialog?.option?.[1]?.[1]();
                    },
                    // 确认删除
                    onConfirm: async () => {
                        useData.dialog?.option?.[0]?.[1]();
                    }
                }}
            />
            {/* 详情弹窗 */}
            <DialogComponent
                defaultHeaderProps={{
                    title: i18n.t('immediate_order_details'),
                    onClose: () => useData.setOpenDetailDialog({ open: false }),
                }}
                open={useData.detailDialogData?.open ?? false}
                sx={(theme) => ({
                    '& .hljs': theme.palette.mode === 'dark' ? {
                        color: '#abb2bf',
                        background: '#282c34',
                    } : {},
                    '& .hljs-attr': theme.palette.mode === 'dark' ? {
                        color: '#d19a66',
                    } : {},
                    '& .hljs-string': theme.palette.mode === 'dark' ? {
                        color: '#98c379',
                    } : {}
                })}
            >
                <Highlight className='json' >
                    {formatJson(useData.detailDialogData?.data || {})}
                </Highlight>
            </DialogComponent>
        </div>
    )
})

export default DeliverectOrderList;